<div class="container my-4">
    <div class="row">
      <div class="col-12 ">
        <span class="title_header_bar">Rain Itemized Billing</span>
      </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">


        <div class="col-md-12 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                <i class="fa fa-refresh"></i> Refresh
              </button> -->
              <app-button (refreshClicked)="clearFilter()"></app-button>

              <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
                <i class="fa fa-file-excel"></i> Export
              </button>
            </div>
          
            <div class="col-xl-3 mb-2" #popupContainer>
              <div class="row">
                <div class="col-xl-12">
                  <div class="dropdown text-right">
                    <div class="btn btn-primary dropdown-toggle" (click)="toggleDropdown()">
                      <i class="icon-calendar"></i>&nbsp;&nbsp;
                      <span class="thin uppercase hidden-xs">{{Month}}</span>
                    </div>
                    <ul class="dropdown-menu dateranges pull-right" [class.show]="dropdownOpen" *ngIf="dropdownOpen" >
                      <li (click)="selectMonth(0); $event.preventDefault()">
                        <a href="" >Current Month</a>
                      </li>
                      <li (click)="selectMonth(1); $event.preventDefault()">
                        <a href="">Last Month</a>
                      </li>
                      <li (click)="selectMonth(2); $event.preventDefault()">
                        <a href="">Custom</a>
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
                <!-- <div>
                  <label for="monthSelect">Select Month and Year:</label>
                  <select [(ngModel)]="selectedOption" (change)="handleMonthSelection()" id="monthSelect">
                    <option [value]="'current'"></option>
                    <option [value]="'last'">Last Month</option>
                    <option [value]="'custom'">Custom</option>
                  </select>
                </div> -->
                
              </div>
          
          </div>
          
        </form>



      <div class="table-responsive mt-2 mb-4">
        <mat-table #table [dataSource]="dataSource" >

          <ng-container matColumnDef="ApplicationNumber">
            <mat-header-cell *matHeaderCellDef >Application Number</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.applicationNumber}}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ConnectionActivationDate">
            <mat-header-cell *matHeaderCellDef >Connection Activation Date</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.connectionActivationDate}} </p>
            </mat-cell>
            </ng-container>
            <ng-container matColumnDef="CustomerName">
                <mat-header-cell *matHeaderCellDef >Customer Name</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                  <p class="text-truncate txtalign"> {{dataField.customerName}} </p>
                </mat-cell>
             </ng-container>
            <ng-container matColumnDef="RainUsername">
                    <mat-header-cell *matHeaderCellDef >RainUser Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                      <p class="text-truncate txtalign"> {{dataField.dslUserName}} </p>
                    </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Comments">
            <mat-header-cell *matHeaderCellDef >Comments</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.annotation}} </p>
            </mat-cell>
            </ng-container>
            <ng-container matColumnDef="CourierReference">
                <mat-header-cell *matHeaderCellDef >Courier Reference</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                  <p class="text-truncate txtalign"> {{dataField.courierRef}} </p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SIMNumber">
                <mat-header-cell *matHeaderCellDef >SIM Number</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                  <p class="text-truncate txtalign"> {{dataField.sIMNumber}} </p>
                </mat-cell>
                </ng-container>
          <ng-container matColumnDef="Action">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <div class="text-truncate text-center">
                <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                (click)="gotoaddactivity(dataField.id)"></i>


              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
          </mat-row>
        </mat-table>
      </div>